import { Component, OnInit } from '@angular/core';
import { httpService } from '../components/body.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ViewContainerRef } from '@angular/core';

import * as forge from "node-forge";
import QRCode from 'qrcode'


@Component({
  selector: 'app-docs',
  templateUrl: './docs.component.html',
  styleUrls: ['./docs.component.css']
})
export class DocsComponent implements OnInit {

  paciente: any;
  cargado: boolean = false;
  fichero: any;
  muestraNuevoQr: boolean = false;
  descripcion: string = '';
  loading: boolean = false;
  imageQr: string;
  muestraMenu: Boolean = true;
  fechaini: any;
  fechafin: any;
  nombreDestinatario: String;
  emailDestinatario: String;
  muestraQr: boolean = false;
  muestraQrCreado: boolean = false;
  muestraMenuQr: boolean = false;
  muestraMenuAlbaran: boolean = false;
  autorizado: boolean = false;
 

  constructor( public http: httpService, public toastr: ToastsManager, vcr: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vcr);
  
   }

   OnInit() {
     this.gestionQr();
   }



  hoy(mfecha) {

    const today = new Date(mfecha);
    let dd = today.getDate().toString();
    let mm = (today.getMonth() + 1).toString();
    let yyyy:string;


    if(today.getDate() < 10) {

        dd = '0'+ dd;
    }

    if (today.getMonth() < 10) {
        mm = '0'+ mm;
    }

    yyyy = today.getFullYear().toString();

    let fecha = yyyy + '-' + mm + '-' + dd;
  
    return  fecha;

}

nuevoQr() {
  if (this.http.esInvitado) {
    this.toastr.error("Esta logueado como invitado. No puede crear Sellos Digitales")
  } else {
      this.muestraMenuQr = false;
      this.muestraNuevoQr = true;
      this.fechaini =  this.hoy(new Date(Date.now()));
      this.fechafin =  this.hoy(new Date(Date.now()));
      console.log(this.fechafin)
      this.nombreDestinatario = '';
      this.emailDestinatario = '';
  }
}

cancelarNuevoQr() {
  this.muestraMenuQr = true;
  this.muestraNuevoQr = false;
}


gestionQr() {
  this.http.paginaactual = 'qrs';
}

cancelarQrCreado() {
  this.muestraMenu = true;
  this.muestraQrCreado = false;
}

crearQr() {
  this.loading = true;
  let body = {
    emisor: this.http.clienteActual._id,
    inicioValidez: this.fechaini,
    finValidez: this.fechafin,
    destinatario: {
      nombre: this.nombreDestinatario.toUpperCase(),
      email: this.emailDestinatario.toLowerCase(),
    },
    estado:'activo',
    activado: true,
    autorizado: this.autorizado
  }

  console.log(body)

  this.http.crearQr(body).subscribe( qr => {
    if (qr.status === 'ok') {
      this.qr(qr.message._id)
      this.sendmail(qr.message);
    } else {
      this.http.showAlerta('Error al crear Sello Digital', 'Crear Sello Digital', 'error')
      this.loading = false;
    }
  })
}

sendmail(qr) {
      this.loading = true;
      let html = `
        <p>Tu Sello Digital</p>
        <p>Su Sello Digital ha sido generado por: ` + this.http.clienteActual.organizacion +
          ` <br><a href="https://sellodigital.smartbiometrik.com?qr=` + qr._id +
          `  ">Ir a su Sello Digital</a>
          <br><a href="https://sellodigital.smartbiometrik.com?login=` + qr._id +
          `  ">Ver sus Sellos Digitaesl</a>`   
      let body = {
        mailTo: qr.destinatario.email,
        asunto: 'Envio de su Sello Digital',
        mensaje: html
      }

      console.log(body);

      this.http.sendmail(body).subscribe( email => {
        console.log(email)
        if (email.status === 'ok') {
          this.loading = false;
          this.toastr.success('Enviado email con éxito')
        } else {
          this.loading = false;
          this.toastr.error('Error al enviar email')
        }
      })
   
}

qr(texto) {
  QRCode.toDataURL(texto)
  .then(url => {
    this.imageQr = url;
    this.muestraNuevoQr = false;
    this.muestraQrCreado = true;
  })
  .catch(err => {
    console.error(err)
  })
}
   
   leerCertificado(file) {
                var reader = new FileReader;
                 
                    reader.readAsBinaryString(file);
                    reader.onload = onLoad;
                 
                
                    function onLoad() {
                      var result = reader.result; // Obtienes el texto
                      // En tu ejemplo lo obtienes de una petición HTTP
                      
                     //console.log(result)
                      
                      var p12Der = reader.result;    //forge.util.decode64(result);
                      console.log('p12Der: ', p12Der)
                      var p12Asn1 = forge.asn1.fromDer(p12Der);
                      console.log('p12Asn: ', p12Asn1);
                      var p12 = forge.pkcs12.pkcs12FromAsn1(p12Asn1, '123456');
                      console.log('p12: ', p12);
                    }
                  
                   
                  /*
                   // get p12 as ASN.1 object
                   // Not working for one of my p12 files
                   var p12Asn1 = forge.asn1.fromDer(p12Der);
                   console.log(p12Asn1);
                   // decrypt p12 using the password 'password'
                   // TODO: Not working for some reason for p12 and pfx file
                   var p12 = forge.pkcs12.pkcs12FromAsn1(p12Asn1, 'adf');
   */
  }

  ngOnInit() {
    this.paciente = this.http.pacienteactual;
    this.cargado = true;
    this.descripcion = '';
  }

  archivo(fichero) {
    this.http.certificado().subscribe( resp => {
      console.log(resp);
    })
  }

  archivo2(fichero) {
    this.fichero = fichero;
    console.log(this.fichero[0]);
    this.descripcion = '';
   // this.muestraDialogo = true;
  }

  subir() {
    this.leerCertificado(this.fichero[0]);
   /*
    if (this.descripcion === '') {
      this.toastr.warning('Debe especificar una descripción.','Atención');
    } else {
        this.loading = true;
        
        this.http.subirfichero(this.fichero[0], this.paciente._id).subscribe( resp => {
          this.paciente.documentos.push({ descripcion: this.descripcion, fichero: './ficheros/pacientes/' + this.paciente._id + '/' + this.fichero[0].name })
          this.http.updatePaciente(this.paciente).subscribe( paciente => {
            this.paciente = paciente.message;
            this.http.pacienteactual = this.paciente;
            this.fichero = null;
            this.muestraDialogo = false;
            this.loading = false;
            this.descripcion = '';
          })
        }, err => {
          this.toastr.warning('Ha ocurrido un error al subir el fichero.','Atención');
          this.fichero = null;
            this.muestraDialogo = false;
            this.loading = false;
            this.descripcion = '';
        }) 
       
    }
    */
  }

  open(fichero) {
    window.open('https://apipruebas.smartbiometrik.com/'  + fichero, '_blank');
  }

}



// WEBPACK FOOTER //
// /Users/usuario/Desktop/Angular/Urbanos/src/app/docs/docs.component.ts